import React from "react";
import TeacherUpgradeModalForm from "../TeacherUpgradeModalForm";
import FakePaypalButton from "./PaypalButton";
import FakeStripePaymentElement from "./StripePaymentElement";

export default function (props) {
  return (
    <TeacherUpgradeModalForm
      {...props}
      PaypalButton={FakePaypalButton}
      StripePaymentElement={FakeStripePaymentElement}
    />
  );
}
